function calcParallax(top, duration, translation) {
    var parallax = parseInt((wb - top)/duration*translation) - translation;
    return(parallax);
}

(function ( $ ) {
    $.fn.parallax = function() {
        var targets = $(this);
            bgs = [],
            mainTranslation = parseInt(wh/8);

        targets.each(function(i) {
            var $that = $(this),
                height = $that.parent().outerHeight(),
                top = $that.offset().top,
                bottom = height + top,
                duration = height + wh,
                translation = parseInt(wh/$that.data('parallax-factor')) || mainTranslation,
                percentage = calcParallax(top, duration, translation);

            $that.css({
                height: height + translation,
                top: percentage
            });

            bgs.push({
                trigger: $that,
                top : top,
                bottom: bottom,
                translation: translation,
                duration: duration
            });

            $window.resize(function(){
                // console.log('here');
                height = $that.parent().outerHeight();
                top = $that.offset().top;
                bottom = height + top;
                duration = height + wh;
                translation = parseInt(wh/$that.data('parallax-factor')) || mainTranslation;
                percentage = calcParallax(top, duration, translation);

                $that.css({
                    height: height + translation,
                    top: percentage
                });

                bgs[i] = {
                    trigger: $that,
                    top : top,
                    bottom: bottom,
                    translation: translation,
                    duration: duration
                }
            })
        });

        return $window.scroll(function(e) {
            e.preventDefault();

            bgs.map(function(elem, i){
                if (elem.top <= wb && elem.bottom >= wt) {
                    elem.trigger.css({
                       'top' : calcParallax(elem.top,  elem.duration,  elem.translation)
                    });
                };
            });
        });
    };
}( jQuery ));

function initParallax() {
    if ($('.js-parallax').length) {
        $('.js-parallax').parallax();
    }
}